jQuery( document ).ready(function() {
    // Check if component is added to the page
    if( jQuery('section.text-image-slider').length ) {

        let $ = jQuery;

        $(".text-image-slider").each(function () {
            $navItems = $(this).find('.slide-nav-item');
            $slides = $(this).find(".slides");


            $navItems.on("click", function (e) {
                var slideNum = $(this).data('slide_for');
                $(this).parents().find(".slides").slick('slickGoTo', slideNum);
            });


            // $slides.on('init', function() {
            //     const height = $(this).outerHeight();
            //     $slideHeight = $slides.outerHeight();
            //     console.log( $slideHeight );
            //     $track = $(this).find('.slick-list');
            //     $slide = $slides.find('.slick-slide');
            //     $slide.css("min-height", height + "px");
            //     $track.css("min-height", height + "px");
            // });
            //
            // $(window).on('resize', function() {
            //     const height = $(this).outerHeight();
            //     $slideHeight = $slides.outerHeight();
            //     console.log( $slideHeight );
            //     $track = $(this).find('.slick-list');
            //     $slide = $slides.find('.slick-slide');
            //     $slide.css("min-height", height + "px");
            //     $track.css("min-height", height + "px");
            // });


            $slides.slick({
                dots: false,
                arrows: false,
                rows: 0,
                // adaptiveHeight: true,
            });

        });


    }
});